<div
  #modal="bs-modal"
  [config]="{ backdrop: 'static' }"
  appBsModal
  aria-hidden="true"
  aria-labelledby="modal"
  class="confirm-delete-modal-control modal fade"
  role="dialog"
  tabindex="-1"
>
  <div class="modal-dialog">
    <div class="modal-content">
      <div class="modal-header">
        <h4 class="modal-title">
            <span>{{"AccountDeletionMessage1" | localize}} </span>
            <span class="highlight-text">{{"AccountDeletionMessage2" | localize}}</span>
            <span>{{'?'}}</span>
        </h4>
      </div>
      <div class="modal-body">
        <p>
            <span>{{"AccountDeletionMessage3" | localize}} </span>
            <span class="highlight-text">{{ tenant?.subscriptionDateString | date:'dd/MM/yy' }}</span>
        </p>
        <p>
            <span>{{"AccountDeletionMessage4" | localize}}</span>
        </p>
      </div>

      <div class="footer">
        <button
          (click)="close()"
          class="btn btn-secondary font-weight-bold"
          type="button"
        >
        {{"Cancel" | localize}}
        </button>

        <button
          (click)="delete()"
          class="btn btn-primary font-weight-bold"
          type="button"
        >
        {{"Delete" | localize}}
        </button>
      </div>
    </div>
  </div>
</div>
